/** Base URL for the Go API (no trailing slash). */
export function getBackendUrl(): string {
  const raw = process.env.BACKEND_URL ?? "http://127.0.0.1:3013";
  return raw.replace(/\/$/, "");
}

export function getPublicSiteUrl(): string {
  return (
    process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "") ??
    "http://localhost:3000"
  );
}

/** Base URL that browsers should use for Go-hosted assets. */
export function getPublicBackendUrl(): string {
  const raw =
    process.env.NEXT_PUBLIC_BACKEND_URL ??
    process.env.BACKEND_URL ??
    "http://127.0.0.1:3013";
  return raw.replace(/\/$/, "");
}

/**
 * CMS uploads and legacy HTML use paths like `/static/img/...` served by the Go API.
 * Next.js runs on a different origin/port, so relative URLs must be prefixed with the API base.
 */
export function resolveApiAssetUrl(url: string | undefined | null): string {
  if (url == null) return "";
  const u = url.trim();
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) {
    // Safety fallback: avoid shipping localhost absolute asset origins in production.
    if (process.env.NODE_ENV === "production") {
      try {
        const parsed = new URL(u);
        const host = parsed.hostname.toLowerCase();
        if (host === "localhost" || host === "127.0.0.1") {
          return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
      } catch {
        // Keep the original URL if parsing fails.
      }
    }
    return u;
  }
  if (u.startsWith("//")) return `https:${u}`;
  const base = getPublicBackendUrl();
  // Safety fallback: avoid shipping localhost asset origins in production.
  // In typical prod deployments, `/static/*` is reverse-proxied on the same host.
  if (
    process.env.NODE_ENV === "production" &&
    /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(base)
  ) {
    return u.startsWith("/") ? u : `/${u}`;
  }
  if (u.startsWith("/")) return `${base}${u}`;
  return `${base}/${u}`;
}
